import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        <div>
            <ul>
                <li><a>FAQ</a></li>
                <li><a>Investor Relations</a></li>
                <li><a>Privacy</a></li>
                <li><a>Speed Test</a></li>
            </ul>
        </div>
        <div>
            <ul>
                <li><a>Help Center</a></li>
                <li><a>Jobs</a></li>
                <li><a>Cookie Preferences</a></li>
                <li><a>Legal Notices</a></li>
            </ul>
        </div>
        <div>
            <ul>
                <li><a>Acoount</a></li>
                <li><a> Ways To Watch</a></li>
                <li><a>Corporate Information</a></li>
                <li><a>Only on Netflix</a></li>
            </ul>
        </div>
        <div>
            <ul>
                <li><a>Media Centre</a></li>
                <li><a>Terms Of Use</a></li>
                <li><a>Contact Us</a></li>
            </ul>
        </div>
    </div>
  )
}

export default Footer